export default {
    required: () => 'Campo obrigatório',
    min: (control) => 'Valor mínimo: ' + control.errors.min.min,
    max: (control) => 'Valor máximo: ' + control.errors.max.max,
    minlength: (control) => 'Tamanho mínimo: ' + control.errors.minlength.requiredLength,
    maxlength: (control) => 'Tamanho máximo: ' + control.errors.maxlength.requiredLength,
    email: () => 'E-mail inválido',
    pattern: () => 'Fora do padrão esperado',
    isCh: (control) => {

        if(control.errors.isCh.invalidLength)
            return 'Tamanho inválido para chave ' + control.errors.isCh.type

        if(control.errors.isCh.modUnknown)
            return 'Modelo desconhecido para chaves'

        if(control.errors.isCh.invalidMod)
            return 'Modelo inválido para chave ' + control.errors.isCh.type

        return 'Não é uma chave ' + control.errors.isCh.type + ' válida'
    }
}
